import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export type Lang = 'fr' | 'en' | 'ar';

export interface TranslatableText {
  fr: string;
  en: string;
  ar: string;
}

export interface SiteSetting {
  id: number;
  site_title: string;
  slogan: string;
  email_contact: string;

  // ── Champs multilingues (objet + version résolue) ───────────────────────
  footer_description: TranslatableText;
  footer_description_text: string | null;

  adresse: TranslatableText;
  adresse_text: string | null;

  adresse2: TranslatableText;
  adresse2_text: string | null;

  // ── Coordonnées ─────────────────────────────────────────────────────────
  telephone: string | null;
  email: string | null;

  // ── Compteurs ───────────────────────────────────────────────────────────
  infractions_publicitaire?: string | number | null;
  missions_controle?: string | number | null;
  licences_actives?: string | number | null;
  licences_suspendus?: string | number | null;

  // ── Réseaux sociaux ─────────────────────────────────────────────────────
  facebook: string | null;
  twitter: string | null;
  linkedin: string | null;
  instagram: string | null;

  logo: string | { url: string; thumb: string } | null;

  // ── Section Google My Maps (page d'accueil) ────────────────────────────
  google_map?: {
    enabled: boolean;
    embed_url: string | null;
    title: TranslatableText;
    title_text: string | null;
    description: TranslatableText;
    description_text: string | null;
  };
}

@Injectable({ providedIn: 'root' })
export class SettingService {
  private base = `${environment.apiUrl}/api/v1`;

  constructor(private http: HttpClient) {}

  /**
   * Récupère les paramètres du site.
   * @param lang code langue (fr|en|ar) — passé en query string pour résoudre
   *             les champs `*_text` côté backend.
   */
  getSettings(lang?: Lang): Observable<SiteSetting> {
    let params = new HttpParams();
    if (lang) params = params.set('lang', lang);

    // Fetch en arrière-plan (header/footer) : un échec ne doit pas rediriger
    // tout le site vers /500 → on désactive la redirection d'erreur globale.
    const headers = { 'X-Skip-Error-Redirect': '1' };

    return this.http
      .get<any>(`${this.base}/settings`, { params, headers })
      .pipe(map(res => res.data ?? res));
  }
}
